// src/components/login/admin/user-types.ts
//
// The user_type values the backend accepts (app/models/auth_models.py
// USER_TYPES) plus the copy that explains each one. Shared by the create and
// edit forms so the two screens can never drift into describing the same role
// differently.

export const USER_TYPES = [
  {
    value: "basic",
    label: "Basic",
    description: "Brand Monitoring + AI Perception + Settings only",
  },
  {
    value: "standard",
    label: "Standard",
    description: "Full access except Workflows / Agents",
  },
  {
    value: "agent",
    label: "Agent",
    description: "Standard + Workflows / Agents",
  },
  {
    value: "admin",
    label: "Admin",
    description: "Everything + User Management",
  },
] as const;

export const DEFAULT_USER_TYPE = "basic";
